import React from "react";
import * as Icons from "lucide-react";
import { SERVICES } from "@/lib/services";

export const ServiceGrid = ({ onSelect }) => (
  <section id="services" className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-10 scroll-mt-28">
    <div className="text-center mb-8">
      <div className="text-xs uppercase tracking-[0.3em] text-[#E65100] font-bold">Pilgrim Services</div>
      <h2 className="font-cinzel text-2xl sm:text-3xl lg:text-4xl font-bold text-amber-950 mt-1">Online Booking Services</h2>
      <div className="sacred-divider w-40 mx-auto mt-4" />
    </div>

    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {SERVICES.filter((s) => !s.hidden).map((s) => {
        const Icon = Icons[s.icon] || Icons.Star;
        return (
          <button
            key={s.id}
            onClick={() => onSelect(s)}
            data-testid={`service-tile-${s.id}`}
            className="group text-left bg-white rounded-xl border border-amber-200/70 p-5 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-200 relative overflow-hidden"
          >
            <span className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#DAA520] to-[#E65100] scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
            <div
              className="w-12 h-12 rounded-lg flex items-center justify-center mb-3 transition-colors"
              style={{ backgroundColor: `${s.color}1a`, color: s.color }}
            >
              <Icon className="w-6 h-6" />
            </div>
            <div className="font-semibold text-amber-950 text-sm leading-snug">{s.short}</div>
            <div className="text-xs text-slate-500 mt-1 line-clamp-2">{s.desc}</div>
            <div className="mt-3 flex items-center justify-between">
              <span className="text-xs font-bold" style={{ color: s.color }}>
                {s.amount > 0 ? `₹${s.amount.toLocaleString("en-IN")}` : s.customAmount ? "Any Amount" : "Free"}
              </span>
              <span className="text-[11px] font-semibold text-[#E65100] group-hover:translate-x-1 transition-transform">Book →</span>
            </div>
          </button>
        );
      })}
    </div>
  </section>
);
